import React, { useMemo } from 'react';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { TranslationBankItemsModel } from 'models/TranslationBankItemsModel';
import { ModalWrapper } from 'components/ModalWrapper';
import { useForceRender } from 'hooks/useForceRender';
import TranslationModel from 'models/TranslationModel';
import { EditorRow } from 'components/common/styles';
import SearchBarDialectRef from 'components/search/SearchBarDialectRef';
import { IItemId } from 'types/content';

interface IProps {
  onClose: () => void;
  itemsModel: TranslationBankItemsModel;
}

const CopyItemModal: React.FC<IProps> = ({ onClose, itemsModel }) => {
  const forceRender = useForceRender();

  const translationModel = useMemo(
    () => new TranslationModel({ render: forceRender, courseId: 0 }),
    [forceRender],
  );

  const handleRowClick = async (data: IItemId) => {
    await itemsModel.createItemFromTranslation(data.id);
  };

  return (
    <ModalWrapper title="Copy from Translation" width={700} height={600} onClose={onClose} disableBackdropClick>
      <ModuleContext.Provider value={translationModel}>
        <EditorRow>
          <p>
            <b>Select a Translation</b>
          </p>
        </EditorRow>
        <SearchBarDialectRef onlySource />
        <Grid handleRowClick={handleRowClick} />
      </ModuleContext.Provider>
    </ModalWrapper>
  );
};

export default CopyItemModal;
